<template>
    <div class="contact">
        <div class="contact-title">
            <h1>Contact</h1>
        </div>
        <div class="content">
            <form class="left" @submit.prevent="contactForm">
                <div class="contactMessage" v-if="messageSent">
                    <span>Email successfully sent. Please wait for the response. Thank you!</span>
                    <h4 @click="closeMessage">X</h4>
                </div>
                <div>
                    <label for="">FullName</label>
                    <input type="text" v-model="fullname" required>
                </div>
                <div>
                    <label for="">Email</label>
                    <input type="email" v-model="email" required>
                </div>
                <div>
                    <label for="">Message</label>
                    <textarea name="" id="" cols="30" rows="10" v-model="message" required></textarea>
                </div>
                <div>
                    <button type="submit">Submit</button>
                </div>
            </form>
            <div class="right">
                <p>If you have any concerns about web development you can reach me out. If youre looking for a web developer that can help you for your project maybe we can talk about it. You can email me using the form.</p>
            </div>
        </div>
    </div>
</template>

<script>
    import emailjs from 'emailjs-com';

    export default {
        name: "Contact",
        data(){
            return {
                fullname: "",
                email: "",
                message: "",
                messageSent: false
            }
        },
        methods: {
            contactForm(){
                emailjs.send("service_lms5hqh","template_cny109r",{
                    from_name: this.fullname,
                    to_name: "Aaron Gabriel Fulgar",
                    message: this.message,
                    reply_to: this.email
                }, "1DH1BFIuFV12HRvBF")

                this.messageSent = true

                this.fullname = ""
                this.email = ""
                this.message = ""
            },
            closeMessage(){
                this.messageSent = false
            }
        }
    }
</script>